<template>
    <div class="about-au">
      <p class="indent"><b>40 ГОДИНИ НЕПРЕКЪСНАТО УСЪВЪРШЕНСТВАНЕ И УСПЕХ</b></p>
      <p class="indent">

      Алкомет АД е най-големият български производител на алуминиеви валцови и пресови продукти, с над 40 годишна история. На площ от 370 000 кв.м., в град Шумен се извършва целият цикъл на производство - от леене на заготовки и рулони до студено валцоване, пресоване и механична обработка  на профили. Компанията предлага широка гама от алуминиеви полуфабрикати – домакинско, обмазано, техническо и опаковачно фолио, финсток, алуминиеви листи и ленти, стандартни и профили по чертеж на клиента.</p>
      <p class="indent">
      През последните 20 години Алкомет инвестира над 155 млн евро в модернизиране на оборудването и устойчиви производствени процеси, фокусирайки се върху намаляването на въглеродните емисии и подобряване нивата на рециклиране. Най-мащабната инвестиционна програма до момента приключи през 2020г., благодарение на която компанията увеличи производствените си капацитети в двата основни цеха. В пресов цех се внедри 25 MN HybrEx® преса, а във валцов цех заработи ново поколение студено валцов стан 6-high-cold-rolling mill.   В началото на 2021 г. бе успешно въведен в експлоатация и нов цех за механична обработка на профили. Инвестицията е на стойност 13,5 мил. лв. , като новото оборудване позволява на компанията да произвежда алуминиеви компоненти, които се влагат в електрическите автомобили.
      </p>
      <p class="indent" style="text-align:center;">
        <img v-scroll-reveal.reset="{ delay: 250 }" src="/static/img/about/au/v1.jpg" alt="">
      </p>
      <p class="indent" style="text-align:center;">
        <img v-scroll-reveal.reset="{ delay: 500 }" src="/static/img/about/au/v2.jpg" alt="">
      </p>


      <p class="indent">
      Алкомет има силно присъствие на европейския и американския пазар, обслужвайки сектори като строителство и архитектура, автомобилостроене, транспорт, производство на опаковки, дистрибуция, производство на енергия от възобновяеми източници и други сектори.
      </p>




        <div class="about-au-img">
            <img v-scroll-reveal.reset src="/static/img/about/au/1.jpg" alt="">
            <img v-scroll-reveal.reset="{ delay: 250 }" src="/static/img/about/au/2.jpg" alt="">
            <img v-scroll-reveal.reset="{ delay: 500 }" src="/static/img/about/au/3.jpg" alt="">
            <p v-scroll-reveal.reset="{ delay: 750 }" class="about-au-img-p">Днес Alcomet се нарежда сред 100-те най-големи български компании по приходи и развитие. Също така, е сред първите 100 най-големи работодатели в България.</p>
        </div>
        <p class="indent">Алкомет е сертифициран по ISO 9001, ISO 14001, ISO 45001, EN 15088, IATF 16949, QUALANOD, QUALICOAT и е силно ангажиран с програми за опазването на околната среда, намаляването на отпадъците и увеличаване ефективността на ресурсите. Непрекъснатите инвестиции в съвременни технологии и оборудване гарантират подобряването на продуктите и устойчивото развитие на компанията.</p>
        <iframe width="560" height="500" src="https://www.youtube.com/embed/kOaJrBzodvg" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
        <app-share-button></app-share-button>
    </div>
</template>

<script>
import ShareButton from "../shared/ShareButton";
export default {
  components: {
    appShareButton: ShareButton
  }
};
</script>

<style scoped>
.about-au p {
  font-size: 19px;
  line-height: 32px;
  margin: 15px auto;
  text-align: justify;
  width: 60%;
}
.about-au-img {
  align-items: center;
  display: flex;
  margin: 40px auto;
  position: relative;
  width: 80%;
  padding-right: 10%;
}
.about-au-img img {
  border-radius: 6px;
  height: auto;
  margin-left: 22px;
  width: calc(33.33% - 22px);
}
.about-au img:last-child {
  padding-right: 0;
}
.about-au-img-p {
  align-items: center;
  background-color: rgba(255, 255, 255, 0.85);
  display: flex;
  font-size: 24px;
  font-weight: 700;
  height: 170px;
  justify-content: center !important;
  text-align: center !important;
  padding: 20px 20px 20px 60px;
  position: absolute;
  right: 0;
  top: calc(50% - 85px);
}
iframe {
  display: block;
  margin: 0 auto;
  width: 60%;
}
@media screen and (max-width: 1280px) {
  .about-au .about-au-img-p {
    font-size: 16px;
  }
}
@media screen and (max-width: 1000px) {
  .about-au p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
  .about-au-img {
    flex-wrap: wrap;
    margin-bottom: 0;
    padding: 0 30px;
    width: 100%;
  }
  .about-au-img img {
    margin-left: 20px;
    width: calc(33.33% - 13.33px);
  }
  .about-au-img img:first-child {
    margin-left: 0;
  }
  .about-au .about-au-img-p {
    font-size: 12px;
    font-weight: 500;
    height: initial;
    line-height: 20px;
    position: static;
    top: initial;
  }
  iframe {
    width: 100%;
    padding: 10px 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/about/AboutUs.vue